import Swal from "sweetalert2";

export const successAlert = (text) => {
  return Swal.fire({
    icon: "success",
    title: "Success",
    text,
  });
};
